import { defineStore } from "pinia";
import { ref } from "vue";
import { API } from "@/queries/index";
import { AxiosError } from "axios";
import { APIResponse, APIResponseError } from "@/types/api";
import { handleResponse, handleResponseError } from "@/utils/api";
import { RoleGroupDataPayload, RoleGroupDataResponse } from "@/types/interface/role-group";

export const useRoleGroupStore = defineStore("roleGroupStore", () => {
  const roleGroup = ref<RoleGroupDataResponse>();
  const roleGroups = ref<RoleGroupDataResponse[]>([]);

  function initRoleGroups(data: any) {
    roleGroups.value = data?.data;
  }

  function addNewRoleGroup(data: any) {
    roleGroup.value = data;
  }

  async function dispatchAll(page = 1, limit = 10, queryParam = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.roleGroup.getRoleGroup(page, limit, queryParam);
      if (status === 200 ) {
        initRoleGroups(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

  async function dispatchDetail(idRoleGroup = "") : Promise<APIResponse<null>> {
    try {
      const { status, data } = await API.roleGroup.findRoleGroup(idRoleGroup);
      if (status === 200 ) {
        addNewRoleGroup(data);
        return handleResponse(status, data);
      }
    } catch (error) {
      const _error = error as AxiosError<APIResponseError>;
      const errorResponseData = _error.response?.data
      return handleResponseError(errorResponseData)
    }
    return handleResponse(200, null);
  }

    async function dispatchCreate(payload: RoleGroupDataPayload) : Promise<APIResponse<null>> {
      try {
        const { status, data } = await API.roleGroup.createRoleGroup(payload);
        if (status === 200 ) {
          addNewRoleGroup(data);
          return handleResponse(status, data);
        }
      } catch (error) {
        const _error = error as AxiosError<APIResponseError>;
        const errorResponseData = _error.response?.data
        return handleResponseError(errorResponseData)
      }
      return handleResponse(200, null);
    }

    async function dispatchUpdate(idRoleGroup = "", payload: RoleGroupDataPayload) : Promise<APIResponse<null>> {
      try {
        const { status, data } = await API.roleGroup.updateRoleGroup(idRoleGroup, payload);
        if (status === 200 ) {
          addNewRoleGroup(data);
          return handleResponse(status, data);
        }
      } catch (error) {
        const _error = error as AxiosError<APIResponseError>;
        const errorResponseData = _error.response?.data
        return handleResponseError(errorResponseData)
      }
      return handleResponse(200, null);
    }

    async function dispatchDelete(idRoleGroup = "") : Promise<APIResponse<null>> {
      try {
        const { status, data } = await API.roleGroup.deleteRoleGroup(idRoleGroup);
        if (status === 200 ) {
          return handleResponse(status, data);
        }
      } catch (error) {
        const _error = error as AxiosError<APIResponseError>;
        const errorResponseData = _error.response?.data
        return handleResponseError(errorResponseData)
      }
      return handleResponse(200, null);
    }

  return {
    roleGroup,
    roleGroups,
    initRoleGroups,
    dispatchCreate,
    dispatchUpdate,
    dispatchDetail,
    dispatchAll,
    dispatchDelete
  };
});